<template>
  <div class="house-importer-checklist">
    <app-panel title="Чек-лист">
      <div>
        <ChecklistRow title="Заполнить тексты для квитанций" class="house-importer-checklist__row" :importInfo="importInfo" objKey="kv_texts"/>
        <ChecklistRow title="Заполнить платежную информацию" class="house-importer-checklist__row" :importInfo="importInfo" objKey="payments_info"/>
        <ChecklistRow title="Добавить новые платежи" class="house-importer-checklist__row" :importInfo="importInfo" objKey="invoices_actualized"/>
        <ChecklistRow title="Добавить новые показания" class="house-importer-checklist__row" :importInfo="importInfo" objKey="new_device_values"/>
        <ChecklistRow title="Проверить начисления на последующие месяцы" class="house-importer-checklist__row" :importInfo="importInfo" objKey="new_charges_checked"/>
        <ChecklistRow title="Завести данные в redis" class="house-importer-checklist__row" :importInfo="importInfo" objKey="redis_accounts"/>
      </div>
    </app-panel>
  </div>
</template>

<script>
  import ChecklistRow from "../components/ChecklistRow";

  export default {
    name: "CheckListPanel",
    components: {
      ChecklistRow
    },
    props: {
      importInfo: {}
    }
  }
</script>

<style lang="scss">
.house-importer-checklist{
  &__row{
    margin-bottom: 15px;
  }
}
</style>